var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIllinoisLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.2959 17.2274V0H8V17.2274H17.8447V46.758H8V63.9854H52.2959V46.758H42.4548V17.2274H52.2959ZM42.4511 49.2164H49.8338V61.5196H10.4621V49.2164H17.8447C19.2037 49.2164 20.3068 48.1132 20.3068 46.7543V17.2274C20.3068 15.8685 19.2037 14.7653 17.8447 14.7653H10.4621V2.4621H49.8374V14.7653H42.4548C41.0959 14.7653 39.9927 15.8685 39.9927 17.2274V46.758C39.9927 48.1169 41.0959 49.2201 42.4548 49.2201L42.4511 49.2164Z",
    fill: "#ffffffff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.4512 14.7651H49.8338V2.46191H10.4622V14.7651H17.8448C19.2037 14.7651 20.3069 15.8683 20.3069 17.2272V46.7578C20.3069 48.1167 19.2037 49.2199 17.8448 49.2199H10.4622V61.5231H49.8375V49.2199H42.4549C41.0959 49.2199 39.9928 48.1167 39.9928 46.7578V17.2272C39.9928 15.8683 41.0959 14.7651 42.4549 14.7651H42.4512Z",
    fill: "#FF5F05"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M56.2412 63.9999H56.0257V62.8054H56.0184L55.5362 63.9999H55.4047L54.9371 62.8054H54.9298V63.9999H54.7143V62.5935H55.065L55.4705 63.5871L55.8869 62.5935H56.2339V63.9999H56.2412ZM54.4622 62.8054H54.002V63.9999H53.7864V62.8054H53.3262V62.5898H54.4622V62.8054Z",
    fill: "#FF5F05"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllinoisLogo);
export default __webpack_public_path__ + "static/media/illinois_logo.81fc57e4861758b1743133b5ad7227f8.svg";
export { ForwardRef as ReactComponent };